var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "2.5",
          y: "7.5",
          width: "19",
          height: "13",
          rx: "2",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M16 20.5V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v14.5",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M2.5 12.5h19",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }